export function loadPaypalSdk(callback) {
  if (window.paypal) {
    // console.log(window.paypal)
    callback(); // Если SDK уже загружен, просто вызываем callback функцию.
    return;
  }

  const script = document.createElement('script');
  script.src = `https://www.paypal.com/sdk/js?client-id=${import.meta.env.VITE_PAYPAL_PUBLIC_KEY}&vault=true&intent=subscription&disable-funding=credit,card`;
  script.setAttribute('data-sdk-integration-source', 'button-factory')
  script.onload = () => callback();
  document.head.appendChild(script);
}
export function loadPaypalSdkForOrder(currency_code, callback) {
  if (window.paypalOrder) {
    callback();
    return;
  }

  const script = document.createElement('script');
  script.src = `https://www.paypal.com/sdk/js?client-id=${import.meta.env.VITE_PAYPAL_PUBLIC_KEY}&currency=${currency_code}&intent=capture`;
  script.setAttribute('data-namespace', 'paypalOrder');
  script.onload = () => callback();
  document.head.appendChild(script);
}



// loadPaypalSdkForOrder(currency_code, () => {
//   setTimeout(() => {
//     if (!this.paypalBtn || !offer.price) return;

//     this.paypalBtn.innerHTML = "";

//     if (this.paypalBtn._paypalButton) {
//       this.paypalBtn._paypalButton.close();
//       this.paypalBtn._paypalButton = null;
//     }
//     paypalOrder.Buttons({
//       style: {
//         shape: 'rect',
//         color: 'gold',
//         layout: 'horizontal',
//         label: 'paypal',
//         tagline: false
//       },
//       createOrder: (data, actions) => {
//         return actions.order.create({
//           purchase_units: [{
//             amount: { value: offer.price, currency_code: currency_code },
//             description: "Lifetime Access"
//           }]
//         });
//       },
//       onApprove: (data, actions) => {
//         return actions.order.capture().then(details => {
//           this.setApprove(offer);
//           if (!this.inputs.length || this.block.classList.contains('offers-last')) {
//             nextSection(this.paypalBtn);
//           }
//         });
//       },
//     }).render(this.paypalBtn);
//   }, this.time);
//   this.time += 300;
// });